import WalkthroughManager from './WalkthroughManager';

export default WalkthroughManager;
